module.exports = __webpack_public_path__ + "img/80.9b14fcb.jpg";